var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document_pending",
    transform: "translate(-86 -527)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(86 527)",
    fill: "#e5be0a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-question",
    "data-name": "Icon awesome-question",
    d: "M5.073,0A3.6,3.6,0,0,0,1.88,1.689a.446.446,0,0,0,.1.61l.8.607a.445.445,0,0,0,.617-.077,1.8,1.8,0,0,1,1.535-.917c.571,0,1.277.367,1.277.921,0,.418-.345.633-.909.949-.657.368-1.527.827-1.527,1.974v.182a.445.445,0,0,0,.445.445H5.559A.445.445,0,0,0,6,5.937V5.83C6,5.035,8.329,5,8.329,2.85A3.188,3.188,0,0,0,5.073,0ZM4.887,6.929A1.285,1.285,0,1,0,6.172,8.214,1.287,1.287,0,0,0,4.887,6.929Z",
    transform: "translate(88.436 529.75)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentPending);
export default __webpack_public_path__ + "static/media/document_pending.70c7c0226b5166055c62a0277eadff92.svg";
export { ForwardRef as ReactComponent };